export const selectedTabAction = selectedTab => ({
    type: 'SELECTED_TAB',
    payload: selectedTab
})